import { z } from 'zod';
import { MAX_QTY } from './money.js';
import { CatalogItemSchema } from './catalog.js';
/**
 * Sablona = skupina zbozi, ktere se kupuje spolu (navrh v2): Pravidelny nakup,
 * Grilovacka, Spagety. Zbozi samo (obchod, cena, hledani v akcich, kody) je
 * sdilene v catalog_items; sablona drzi jen, co do ni patri a kolik.
 */
export const TEMPLATE_NAME_MAX = 60;
export const REGULAR_TEMPLATE_NAME = 'Pravidelný nákup';
export const TemplateItemSchema = z.object({
    catalogItemId: z.uuid(),
    /** null = obvykle mnozstvi zbozi (defaultQty). */
    qty: z.number().positive().max(MAX_QTY).nullable(),
});
export const TemplateSchema = z.object({
    id: z.uuid(),
    groupId: z.uuid(),
    name: z.string().min(1).max(TEMPLATE_NAME_MAX),
    /** Puvodni sablona skupiny: nejde smazat, ve vyberu ma „Asi dochází" a nic se nepredvybira. */
    regular: z.boolean(),
    /** Akce jejiho zbozi jsou v „Ze šablon v akci" a chodi na ne upozorneni. */
    watchOffers: z.boolean(),
    position: z.number().int().nonnegative(),
    items: z.array(TemplateItemSchema),
    createdAt: z.iso.datetime(),
});
const templateName = z.string().trim().min(1).max(TEMPLATE_NAME_MAX);
export const TemplateInputSchema = z.object({
    name: templateName,
    watchOffers: z.boolean().default(false),
});
export const TemplatePatchSchema = z.object({
    name: templateName.optional(),
    watchOffers: z.boolean().optional(),
    position: z.number().int().nonnegative().max(1000).optional(),
});
export const TemplateItemQtySchema = z.object({
    qty: z.number().positive().max(MAX_QTY).nullable(),
});
/** Pridani zbozi do sablony podle nazvu: zname zbozi skupiny se pouzije, jinak se zalozi. */
export const TemplateItemAddSchema = z.object({
    name: z.string().trim().min(1).max(200),
    storeId: z.uuid().nullable().default(null),
    qty: z.number().positive().max(MAX_QTY).nullable().default(null),
    unit: z.string().trim().max(20).nullable().default(null),
});
export const TemplatesResponseSchema = z.object({ templates: z.array(TemplateSchema) });
export const TemplateItemAddResponseSchema = z.object({
    item: CatalogItemSchema,
    template: TemplateSchema,
    /** false = zbozi uz skupina znala (treba z Pravidelneho nakupu). */
    created: z.boolean(),
});
const SOURCE_PATTERN = /^(template|trip):([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;
/** „watched", „template:<id>", „trip:<id>"; bez hodnoty vse. null = nesmysl. */
export function parseMatchSource(text) {
    if (!text || text === 'all')
        return { kind: 'all' };
    if (text === 'watched')
        return { kind: 'watched' };
    const m = SOURCE_PATTERN.exec(text);
    if (!m?.[1] || !m[2])
        return null;
    return { kind: m[1].toLowerCase() === 'trip' ? 'trip' : 'template', id: m[2].toLowerCase() };
}
export function matchSourceKey(source) {
    return source.kind === 'template' || source.kind === 'trip' ? `${source.kind}:${source.id}` : source.kind;
}
//# sourceMappingURL=templates.js.map